<template>
    <div>
        <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8">
            <div class="row mb-2">
                <div class="col-12 col-md-12 col-lg-8">
                    <h1 class="text-white pt-3 px-3">รายงานยอดการส่งด้วยระบบ COD </h1>
                    <p class="text-white pb-0 px-3" >
                        แสดงข้อมูลการใช้งานระบบ และรายละเอียด COD
                    </p>
                </div>
                <div class="col-12 col-md-12 col-lg-4 align-self-center text-right">
                    <h1 class="display-3 text-white">
                        <small>จำนวนพัสดุ :</small>
                        {{filterData.length}}
                        <small>ชิ้น</small>
                    </h1>
                </div>
            </div>
        </base-header>
        <div class="text-center" v-if="busy">
            <BlockUI>
                <div class="loader"></div>
            </BlockUI>
        </div>
        <!-- head table -->
        <div class="container-fluid mt--7 mb-5">
            <div class="row">
                <div class="col">
                    <div class="card shadow">
                        <div class="card-header bg-transparent">
                            <Management 
                                :filter="{  'date'          : filters , 
                                            'shopList'      : shop_list ,
                                            'filterOfType'  : filterType 
                                        }"
                                :listOrders="filterData"
                                :func="{
                                    'getReportCod' : getReportCod ,
                                    'fetchOrders' : fetchOrders
                                }"
                                :pagination="pagination"
                            ></Management>
                        </div>
                        <TableOrderCod :listOrders="filterData" :pagination="pagination"></TableOrderCod>
                    </div>
                </div>
            </div>
        </div>
        <!-- head table end -->
        <ModalNotification :notiShop="noti" />
    </div>
</template>
<script>
import moment from "moment"
import validatePop from "../../plugins/validatePop.js"
import ModalNotification from '@/components/custom/ModalNotification'
import TableOrderCod from '@/components/custom/reports/cod/ListOrder'
import Management from '@/components/custom/reports/cod/Management'
import { checkStatusShop } from "@/axios/noti.js";

const API_URL = process.env.VUE_APP_API;
export default {
    components:{
        ModalNotification ,
        TableOrderCod ,
        Management
    },
    data(){
        return {
            userLogin:'',
            busy: false ,
            shop_list:[],
            filterShop:[],
            filterType:{
                textFilter:"",
                fetchFilter:'receipt',
                statusParcel: null,
                selectShopFilter: null
            },
            data:[],
            filters: {
                dateRange:{ 
                    startDate: moment().format("YYYY-MM-DD"),
                    endDate: moment().format("YYYY-MM-DD")
                },
                date_excel: moment(new Date(), "YYYY-MM-DD").format("YYYY-MM-DD")
            },
            noti:{
                show:false,
                type:"",
                created_by:"",
                router:false
            },
            pagination: {
                current_page: 0,
                per_page: 0,
                total_item: 0,
                getOrder: this.getReportCod
            }
        }
    },
    beforeMount(){
        this.userLogin = JSON.parse(localStorage.getItem("user"))
    },
    mounted() {
        if(this.$USER_LOGIN.get().isSuperadmin){
            checkStatusShop().then(res => {
                if( res.status_shop == 'LOCK' ){
                    this.noti.created_by = res.created_by
                    this.noti.type = res.status_shop
                    this.noti.show = true
                }
            })
        }
        if(this.$route.query.date_start && this.$route.query.date_end) {
            this.findShippopQUERY();
        } else {
            this.getReportCod()
        }
    },
    computed:{
        filterData(){
            return this.data
        }
    },
    methods:{
        findShippopQUERY () {
            if(this.$route.query.date_start && this.$route.query.date_end) {
                this.filters['dateRange']['startDate'] = this.$route.query.date_start ? moment(this.$route.query.date_start).format("YYYY-MM-DD") : moment().format("YYYY-MM-DD")
                this.filters['dateRange']['endDate'] = this.$route.query.date_end ? moment(this.$route.query.date_end).format("YYYY-MM-DD") : moment().format("YYYY-MM-DD")
            }
        },
        async getReportCod(){
            this.busy = !this.busy
            let res = await this.getOrderCodAPI()
            let checkError = validatePop(res);
            if (!checkError.status) {
                if (checkError.notices == "token is expired") {
                this.$router.push("/logout");
                }
                this.busy = false;
                this.showErrorModal(checkError.msg);
                return;
            }
            let result = res.data.data
            this.data = result.orders
            this.pagination.current_page = result.current_page
            this.pagination.per_page = result.per_page
            this.pagination.total_item = result.total_item
            this.shop_list = result.shop_list
            this.busy = !this.busy
        },
        async getOrderCodAPI(){
            return await this.$http.post( API_URL + "/shop/order/cod", {
                start:  moment(this.filters.dateRange.startDate).format("YYYY-MM-DD"),
                end: moment(this.filters.dateRange.endDate).format("YYYY-MM-DD"),
                shop: this.filterType.selectShopFilter,
                statusParcel :  this.filterType.statusParcel,
                ...( ( this.$route.params.Id ) ? { mem_id: this.$route.params.Id } : {} ),
                page: this.pagination.current_page
            },
            {
                headers: {
                    Token: localStorage.getItem("access_token")
                }
            })
        },
        fetchOrders(){
            this.busy = !this.busy
            this.$http.post( API_URL + "/order/fetch", {
                query: this.filterType.textFilter,
                type: this.filterType.fetchFilter,
                ...( ( this.$route.params.Id ) ? { mem_id: this.$route.params.Id } : {} ),
            },
            {
                headers: {
                    Token: localStorage.getItem("access_token")
                }
            }
            )
            .then(res => {
            let checkError = validatePop(res);
            if (!checkError.status) {
                if (checkError.notices == "token is expired") {
                this.$router.push("/logout");
                }
                this.busy = false;
                this.showErrorModal(checkError.msg);
                return
            }
                let result = res.data.data
                this.data = result.orders
                this.resetValuePagenate()
                this.busy = !this.busy
            })
        },
        resetValuePagenate(){
            this.pagination.current_page = 1
            this.pagination.per_page = 1
            this.pagination.total_item = 0
        },
        showErrorModal(msgBody) {
            this.$bvModal.msgBoxOk(msgBody, {
                title: "ERROR",
                size: "sm",
                buttonSize: "sm",
                okVariant: "danger",
                okTitle: "ลองอีกครั้ง",
                contentClass: "modal-errors",
                headerClass: "p-2 border-bottom-0",
                footerClass: "p-2 border-top-0",
                centered: true
            })
        }
    },
    watch: {
        '$route' (to, from) {
            if(from.name == 'reportcodmember'){
                this.getReportCod()
            }
        }
    },
}
</script>
<style lang="scss" scoped>
    .report{
    color: #212529;
    font-size: 1.1rem;
    width: 100%;
    }

</style>